import axios from 'axios';
import { ROOT_URL } from '../globals';

export const SHOPPING_LIST_LIST_UPDATE_MEMBER = 'shopping_list_list_update_mbr';
export const FETCH_SLL_BEGIN   = 'FETCH_SLL_BEGIN';
export const FETCH_SLL_SUCCESS = 'FETCH_SLL_SUCCESS';
export const FETCH_SLL_FAILURE = 'FETCH_SLL_FAILURE';

export const fetchSLLBegin = () => ({
    type: FETCH_SLL_BEGIN
  });
  
  export const fetchSLLSuccess = ListOfLists => ({
    type: FETCH_SLL_SUCCESS,
    payload:  ListOfLists 
  });
  
  export const fetchSLLFailure = error => ({
    type: FETCH_SLL_FAILURE,
    payload: { error }
  });

  export function fetchAccountShopLists(acctId) {
    return dispatch => {
      const url = `${ROOT_URL}ShoppingLists/GetShoppingLists/?acctId=${acctId}`;
      dispatch(fetchSLLBegin());
      axios.get(url)
        .then (function(result) {
          dispatch(fetchSLLSuccess(result));
          return result;
        })
        .catch(error => dispatch(fetchSLLFailure(error)));
    };
  }
  
  



// WEBPACK FOOTER //
// ./src/actions/shopping_list_list_actions.js